export default __webpack_public_path__ + "static/media/logo-make-in-india.60b45df7.png";